import { useToast } from '@components/index'
import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useOnError } from '@services/utils/onError'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

interface DeleteProtocolParams {
  flatId: string
  protocolId: string
}

export function useDeleteProtocol() {
  const toast = useToast()
  const { t } = useTranslation('toast')
  const queryClient = useQueryClient()
  const onError = useOnError()

  async function deleteProtocol({ flatId, protocolId }: DeleteProtocolParams) {
    const res = await apiClient.delete(
      `${SNA_PREFIX}flats/${flatId}/protocols/${protocolId}`
    )

    return res.data
  }

  return useMutation({
    mutationFn: deleteProtocol,
    onSuccess: (_, variables) => {
      toast.success({ message: t('protocolDeleted') })
      queryClient.invalidateQueries({ queryKey: ['flat-protocols', variables.flatId] })
    },
    onError
  })
}
